const FIELD_TYPE = Object.freeze({
  HEADER: 'header',
  SUBHEADER: 'text-entry',
  DIVIDER: 'divider',
  ROW: 'row',
  CHECKBOX: 'checkbox',
  TIME: 'time',
  CHECKBOX_GROUP: 'checkbox-group',
  RADIO_GROUP: 'radio-group',
  ACCORDION: 'accordion',
  CURRENCY: 'currency',
  SHORT_TEXT_ENTRY: 'text',
  LONG_TEXT_ENTRY: 'textarea',
  PHONE: 'phone',
  SSN: 'ssn',
  DROPDOWN: 'select',
  FILE_UPLOAD: 'file',
  IMAGE_UPLOAD: 'image-upload',
  SYSTEM_ID: 'systemid',
  DATE_FIELD: 'date',
  NUMBER: 'number',
  SCALE_RATING: 'rating',
  ADDRESS: 'address',
  ELECTRONIC_SIGNATURE: 'signature',
  CASE_MANAGER: 'select2',
  CASE_MANAGER_SECONDARY: 'select_case_manager_secondary',
  SHARED_FIELD: 'shared-field',
  SHARED_FORM_PREVIEW: 'shared-form-preview',
});

export {FIELD_TYPE}




// WEBPACK FOOTER //
// ./src/enums/fieldType.js